module.exports = "/img/notification.svg?e0e13f9031483c2e3c631dc45878551f";